import {Component, OnInit, inject, ViewChild, ElementRef} from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import {catchError} from "rxjs/operators";
import {SystemApp} from "../../constans/SystemConfigurations";
import {ApiUrl} from "../../shared/models/apiurl.models";
import {Router} from "@angular/router";
import {ContactMenuComponent} from "../contact-menu/contact-menu.component";
import { DragScrollDirective } from '../../shared/directives/drag-scroll.directive';
import { CardBizBadgesComponent, CardDealerComponent } from '../card-seller/card-seller.component';

interface PetCity {
  id: number;
  nameHe: string;
  nameEng: string;
}

interface PetOption {
  id: number;
  label: string;
  icon: string;
}

interface PetImage {
  image: string;
  SortNum: number | null;
}

interface Pet {
  id: number;
  petType: PetOption;
  breed: PetOption;
  petName: string;
  listingType: PetOption;
  age: PetOption;
  gender: PetOption;
  size: PetOption;
  color: string;
  city: PetCity;
  region: PetOption;
  description: string;
  name: string;
  price: number;
  priceNegotiable: boolean;
  freeAdoption: boolean;
  vaccinated: boolean;
  neutered: boolean;
  trained: boolean;
  pedigree: boolean;
  kidFriendly: boolean;
  suitableForYard: boolean;
  suitableForApartment: boolean;
  suitability: string[];
  sellerType: PetOption;
  images: PetImage[];
  video_url: string | null;
  /** Present on every product; used to detect internal (admin) ads merged into this listing. */
  resourcetype?: string;
}

interface PetResponse {
  page_size: number;
  object_list: Pet[];
}

@Component({
    selector: 'app-pet-listings',
    imports: [ContactMenuComponent, DragScrollDirective, CardBizBadgesComponent, CardDealerComponent],
    templateUrl: 'pet.component.html',
    styleUrls: ['pet.component.scss']
})
export class PetListingsComponent implements OnInit {
  private http = inject(HttpClient);
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }
  pets: Pet[] = [];
  isLoading = false;
  error: string | null = null;
  constructor(private apiKey: ApiUrl, private route: Router) {
  }
  private apiUrl = SystemApp.base_url_api+'/clientAjax/productVFilteriewSet';

  ngOnInit(): void {
    this.loadPets();
  }

  loadPets(): void {
    this.isLoading = true;
    this.error = null;

    this.http
        .post<PetResponse>(
            `${this.apiUrl}?limit=36&offset=1&model_class=pet`,
            {},
            { headers:this.options.headers }
        )
        .pipe(
            catchError((err) => {
              this.error = err.message;
              this.isLoading = false;
              return of(null);
            })
        )
        .subscribe((res) => {
          if (res) {
            this.pets = res.object_list;
          }
          this.isLoading = false;
        });
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src =
        'https://placehold.co/400x300/f0ebe3/c4a882?text=🐾';
  }
  openPage(id:any){
    this.route.navigate([`single/${id}`])
  }
  sendMessageOrCall($event:Event){
    $event.stopPropagation();
    $event.preventDefault();
  }

  getColorHex(color: string): string {
    const map: Record<string, string> = {
      'לבן': '#f5f5f5',
      'שחור': '#2a2a2a',
      'חום': '#8B6914',
      'אפור': '#999',
      'זהוב': '#DAA520',
      'כתום': '#E87830',
    };
    return map[color] || '#ccc';
  }

  isHighlightTag(tag: string): boolean {
    return ['מחוסנ/ת', 'מעוקר/ת', 'ידידותי לילדים'].includes(tag);
  }

  getTagIcon(tag: string): string {
    const icons: Record<string, string> = {
      'מחוסנ/ת': '💉',
      'מעוקר/ת': '✓',
      'מאולפ/ת': '🎓',
      'תעודת יוחסין': '📜',
      'ידידותי לילדים': '👶',
      'מתאים לחצר': '🏡',
      'מתאים לדירה': '🏢',
    };
    return icons[tag] || '•';
  }

  // Inside the class:
  @ViewChild('petTrack') petTrack!: ElementRef<HTMLElement>;

  scrollLeft(): void {
    this.petTrack.nativeElement.scrollBy({ left: -360, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.petTrack.nativeElement.scrollBy({ left: 360, behavior: 'smooth' });
  }

  navigateToPage() {
    this.route.navigate([`shop/pet`])
  }

  /**
   * Internal (admin) ads linked to this category are merged into the same
   * listing by the backend. They only carry the generic Product fields
   * (name/price/images/description/city), none of the pet-specific ones —
   * so they need a simpler card.
   */
  isInternalAd(pet: Pet): boolean {
    return (pet.resourcetype || '').toLowerCase() === 'internalads';
  }
}